import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function DocumentViewer({ title, children, fileName = "document" }) {
  const printRef = useRef(null);
  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({ content: () => componentRef.current });

  const handleDownloadPDF = async () => {
    const node = componentRef.current;
    if (!node) return;
    const canvas = await html2canvas(node, { scale: 2, useCORS: true, backgroundColor: "#ffffff" });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${fileName}.pdf`);
  };

  return (
    <div>
      <div className="flex-between mb-16" style={{ flexWrap: "wrap", gap: 10 }}>
        <h3 style={{ fontSize: 18 }}>{title}</h3>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn btn-outline" onClick={handlePrint}>
            <i className="ti ti-printer"></i> Print
          </button>
          <button className="btn btn-primary" onClick={handleDownloadPDF}>
            <i className="ti ti-download"></i> Download PDF
          </button>
        </div>
      </div>
      <div ref={componentRef}>{React.Children.map(children, (c) => c)}</div>
    </div>
  );
}
